export enum RequestStatus {
  IDLE,
  RUNNING,
  SUCCESS,
  ERROR,
}
